import React, { useContext } from 'react'
import "./index.css"
import CustomCheckBox from '../../../../components/CustomFormTag/checkbox'
import { IoShieldCheckmark } from "react-icons/io5";
import { filterDataContext } from '../../../../App';
import { MdShoppingCartCheckout } from "react-icons/md";
import MarkupInput from '../../../../components/addMarkup';

const CheckoutBooking = ({ isBooking, values, orderTotalValue, setFieldValue, isToShowSupplierShow, timeRemaining, checkForCheckoutPage, scrollToFirstError, errors }) => {
    const { cartData } = useContext(filterDataContext)

    return (
        <div className='checkout_booking' >
            {
                isToShowSupplierShow && cartData.length > 0 && !checkForCheckoutPage &&
                <MarkupInput totalPrice={orderTotalValue} allDisabled={checkForCheckoutPage} />
            }
            {cartData.length > 0 && <CustomCheckBox checkForCheckoutPage={checkForCheckoutPage} text={"I accept the General Terms and Conditions"} value={values?.termsAndCondition} setValue={setFieldValue} name={"termsAndCondition"} shwoPdfOption />}
            <button type="submit" disabled={cartData.length === 0 || isBooking || timeRemaining === "Time expired"} title={timeRemaining === "Time expired" ? "Reservation expired" : ""} onClick={() => scrollToFirstError(errors)} >
                {checkForCheckoutPage ? (
                    <>
                        <IoShieldCheckmark /> Complete Booking
                    </>
                ) : (
                    <>
                        <MdShoppingCartCheckout /> Checkout
                    </>
                )}
            </button>
        </div>
    )
}

export default CheckoutBooking;